import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import { fieldsProps } from './schema';
import Select from '../../fields/SelectBox';
import Text from '../../fields/Text';
import {
  fetchCities,
  fetchDistricts,
  fetchProvinces,
  fetchVillages,
} from '../../layouts/PageBase/actions';
import Coordinates from '../../fields/Coordinates';
import { useEditMerchant } from '../../../pages/SettingMerchant/hooks';

export default function EditMerchantForm({
  handleOpenModal,
  invalid,
  // handleSubmit = () => {},
  // initialValues = {}
}) {
  const {
    registrationId,
    storeName,
    ownerName,
    nationalityId,
    email,
    phoneNumber,
    storePhoneNumber,
    provinceId,
    cityId,
    districtId,
    villageId,
    zipcode,
    street,
    coordinate,
  } = fieldsProps;

  const dispatch = useDispatch();
  const { dataProvinces, dataCities, dataDistricts, dataVillages } =
    useSelector((state) => state.pageBase);
  const { values } = useSelector((state) => state.form.formEditMerchant);
  const { message, loading } = useSelector(
    (state) => state.merchantSetting.edit
  );
  const { handleCancel } = useEditMerchant('formEditMerchant');

  useEffect(() => {
    dispatch(fetchProvinces());
    if (values.provinceId) {
      dispatch(fetchCities({ provinceId: JSON.stringify(values.provinceId) }));
    }
    if (values.cityId) {
      dispatch(fetchDistricts({ cityId: JSON.stringify(values.cityId) }));
    }
    if (values.districtId) {
      dispatch(fetchVillages({ districtId: JSON.stringify(values.districtId) }));
    }
  }, [values.provinceId, values.cityId, values.districtId, values.regionalId]);

  return (
    <form className={styles.form} encType="multipart/form-data">
      <div>
        {message ? <p className={styles.error}>{message}</p> : null}
        <div className={styles.info}>
          <span className={styles.notRequired}>
            <Field
              component={Text}
              inputProps={registrationId}
              name={registrationId.name}
              showErrorWithoutTouched
            />
          </span>
          <Field
            component={Text}
            inputProps={ownerName}
            name={ownerName.name}
            showErrorWithoutTouched
          />
          <Field
            component={Text}
            inputProps={storeName}
            name={storeName.name}
            showErrorWithoutTouched
          />
          <Field
            component={Text}
            inputProps={nationalityId}
            isNumber={true}
            name={nationalityId.name}
            showErrorWithoutTouched
          />
          <Field
            component={Text}
            inputProps={email}
            name={email.name}
            showErrorWithoutTouched
          />
          <Field
            component={Text}
            inputProps={phoneNumber}
            // isNumber={true}
            name={phoneNumber.name}
            showErrorWithoutTouched
          />
          <Field
            component={Text}
            inputProps={storePhoneNumber}
            // isNumber={true}
            name={storePhoneNumber.name}
            showErrorWithoutTouched
          />
        </div>
        <div className={styles.address}>
          <p>Alamat Pangkalan LPG 3 Kg</p>
          <div>
            <Field
              component={Select}
              data={dataProvinces}
              inputProps={provinceId}
              name={provinceId.name}
              onClearFields={() => {
                dispatch(change('formEditMerchant', 'cityId', ''));
                dispatch(change('formEditMerchant', 'districtId', ''));
                dispatch(change('formEditMerchant', 'villageId', ''));
              }}
            />
            <Field
              component={Select}
              data={dataCities}
              inputProps={cityId}
              name={cityId.name}
              onClearFields={() => {
                dispatch(change('formEditMerchant', 'districtId', ''));
                dispatch(change('formEditMerchant', 'villageId', ''));
              }}
            />
            <Field
              component={Select}
              data={dataDistricts}
              inputProps={districtId}
              name={districtId.name}
              onClearFields={() => {
                dispatch(change('formEditMerchant', 'villageId', ''));
              }}
            />
            <Field
              component={Select}
              data={dataVillages}
              inputProps={villageId}
              name={villageId.name}
            />
            <Field
              component={Text}
              inputProps={zipcode}
              isNumber={true}
              name={zipcode.name}
              showErrorWithoutTouched
            />
            <Field
              component={Text}
              inputProps={street}
              name={street.name}
              showErrorWithoutTouched
            />
            <Field
              component={Coordinates}
              inputProps={coordinate}
              name={coordinate.name}
            />
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          disabled={loading}
          onClick={handleCancel}
          style="default"
          type="button"
        >
          Batalkan
        </Button>
        <Button
          disabled={loading || invalid}
          onClick={handleOpenModal}
          type="button"
        >
          Simpan
        </Button>
      </div>
    </form>
  );
}

EditMerchantForm.propTypes = {
  handleOpenModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
};
